import cx from "classnames";
import { MagnifyOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/MagnifyOutlined";
import styles from "./ZoomTooltip.module.scss";

export interface ZoomTooltipProps {
  zoomLabelPosition?: { left: string; top: string };
  className?: string;
  showIconOnly: boolean;
  toolTipText?: string;
}

export const ZoomTooltip = ({
  zoomLabelPosition,
  className,
  showIconOnly,
  toolTipText = "Click to zoom",
}: ZoomTooltipProps) => {
  return (
    <div
      className={cx(styles["zoom-label"], className)}
      style={
        zoomLabelPosition
          ? {
              transform: `translate(${zoomLabelPosition.left}, ${zoomLabelPosition.top})`,
            }
          : undefined
      }
      data-cy="zoom-label"
    >
      <div className={styles.magnify_container} data-testid="zoomtooltip:icon">
        <MagnifyOutlined className={styles.magnify} size="medium" />
      </div>
      {!showIconOnly && (
        <div
          className={styles.zoom_tooltip_container}
          data-testid="zoomtooltip:text"
        >
          {toolTipText}
        </div>
      )}
    </div>
  );
};
